import { render, staticRenderFns } from "./SwitchIdentity.vue?vue&type=template&id=643a8014&scoped=true"
import script from "./SwitchIdentity.vue?vue&type=script&lang=js"
export * from "./SwitchIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a8014",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643a8014')) {
      api.createRecord('643a8014', component.options)
    } else {
      api.reload('643a8014', component.options)
    }
    module.hot.accept("./SwitchIdentity.vue?vue&type=template&id=643a8014&scoped=true", function () {
      api.rerender('643a8014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/SwitchIdentity.vue"
export default component.exports